import React, { Component } from 'react';
import './loader.css';

class Loader extends Component {

    render() {

        return (
            <div className="loader_wrapper">
                <div className="loader_card">
                    <div className="loader"></div>
                    אנא המתן...
                </div>
            </div>
        )
    }
}

export default Loader;
